module.exports = __webpack_public_path__ + "img/fulfilment-ratio-tag.05d8a16.png";